// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dIx1S3uqtKbMg7 {
  display: block;
}
.vJQaz8eEy4RxBE {
  display: none;
}
.eckfIwDfWb4h59 {
  display: flex;
  width: 100%;
}
.eckfIwDfWb4h59 h3 {
  padding-bottom: var(--ds-space-200, 14px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
}
.vgdmzwmdLmbaDJ {
  transition: opacity 0.3s ease;
}
@media (prefers-reduced-motion: reduce) {
  .vgdmzwmdLmbaDJ {
    transition: none;
  }
}
.TkyaiuIDpBbtvN {
  width: calc(680px + ((100vw - 960px) / 2));
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 28px var(--ds-space-0, 0) 66.5px var(--ds-space-0, 0);
  box-shadow: var(--ds-shadow-raised, inset 0 24px 14px -14px rgba(9, 30, 66, 0.15));
  font-size: 16px;
}
@media (min-width: 1200px) {
  .TkyaiuIDpBbtvN {
    width: calc(807.5px + ((100vw - 1140px) / 2));
  }
}
.TkyaiuIDpBbtvN > div {
  display: flex;
  flex-direction: column;
  width: 640px;
  margin: var(--ds-space-0, 0) var(--ds-space-500, 40px) var(--ds-space-0, 0) auto;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-0, 0) 28px var(--ds-space-0, 0) var(--ds-space-200, 14px);
  gap: var(--ds-space-200, 14px);
}
@media (min-width: 1200px) {
  .TkyaiuIDpBbtvN > div {
    width: 760px;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin: var(--ds-space-0, 0) 47.5px var(--ds-space-0, 0) auto;
  }
}
.bfgVFw2oJ9nLr0 {
  width: calc(280px + ((100vw - 960px) / 2));
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 28px var(--ds-space-0, 0) 66.5px;
  background-color: var(--ds-background-accent-purple-subtlest, rgba(234, 230, 255, 0.4));
  box-shadow: var(--ds-shadow-raised, inset 0 24px 14px -14px rgba(9, 30, 66, 0.15));
}
@media (min-width: 1200px) {
  .bfgVFw2oJ9nLr0 {
    width: calc(332.5px + ((100vw - 1140px) / 2));
  }
}
.bfgVFw2oJ9nLr0 > div {
  width: 240px;
  margin: calc(var(--ds-space-0, 0) auto var(--ds-space-0, 0) calc(var(--ds-space-500, 40px) - var(--ds-space-200, 14px)));
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
@media (min-width: 1200px) {
  .bfgVFw2oJ9nLr0 > div {
    width: 285px;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin: var(--ds-space-0, 0) auto var(--ds-space-0, 0) calc(47.5px - var(--ds-space-200, 14px));
  }
}
.bfgVFw2oJ9nLr0 > div p {
  margin-bottom: var(--ds-space-100, 8px);
}
.bfgVFw2oJ9nLr0 h3 {
  margin-bottom: var(--ds-space-200, 14px);
  border-bottom-color: var(--ds-border-accent-purple, #998dd9);
}
.xi3RXvwHWi1ptr {
  display: flex;
  flex-wrap: wrap;
  margin: var(--ds-space-0, 0) var(--ds-space-negative-200, -14px);
  gap: var(--ds-space-200, 14px) var(--ds-space-0, 0);
}
.hVzg16GbmntBpo {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-200, 14px);
  margin: var(--ds-space-negative-200, -14px);
  padding: var(--ds-space-300, 24px) var(--ds-space-0, 0);
  text-decoration: none;
}
.hVzg16GbmntBpo a {
  padding-bottom: var(--ds-space-0, 0);
  text-decoration: none;
}
.hVzg16GbmntBpo p:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.xi3RXvwHWi1ptr > a {
  width: 33.33333%;
  text-decoration: none;
}
.xi3RXvwHWi1ptr > a > p:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var detailVisible = `dIx1S3uqtKbMg7`;
export var detailHidden = `vJQaz8eEy4RxBE`;
export var detail = `eckfIwDfWb4h59`;
export var detailInner = `vgdmzwmdLmbaDJ`;
export var detailPrimary = `TkyaiuIDpBbtvN`;
export var detailSecondary = `bfgVFw2oJ9nLr0`;
export var detailPrimaryLinks = `xi3RXvwHWi1ptr`;
export var detailSecondaryLinks = `hVzg16GbmntBpo`;
export default ___CSS_LOADER_EXPORT___;
